<div class="panel-content-actions">

	<button data-testid="SUBSYS2_PLANLIST_ACTION_VIEWCASE" class="btn" [class.pe-auto]="isViewTooltipVisible()"
		[title]="labels().PLAN_ACTION_COMPONENT_VIEW" (click)="view()" (keypress)="view()"
		[disabled]="isDisabled() || !isViewEnabled()"
		[ngbTooltip]="isViewTooltipVisible() ? labels().PLAN_ACTION_COMPONENT_VIEW_DISABLED : null" placement="top"
		tooltipClass="white-tooltip">
		<i class="material-icons">visibility</i>
		<div>{{ labels().PLAN_ACTION_COMPONENT_VIEW }}</div>
	</button>
	<button data-testid="SUBSYS2_PLANLIST_ACTION_ANALYSIS" class="btn" [title]="labels().PLAN_ACTION_COMPONENT_GO_RAY"
		(click)="navigateToApp()" (keypress)="navigateToApp()" [disabled]="isDisabled() || !isAnalysisEnabled()">
		<i class="material-icons fake-material-icon analysis"></i>
		<div>{{ labels().PLAN_ACTION_COMPONENT_GO_RAY }}</div>
	</button>
	<button data-testid="SUBSYS2_PLANLIST_ACTION_POSTOPCREATE" class="btn"
		[title]="labels().PLAN_ACTION_COMPONENT_POSTOP_CREATE" (click)="openPostopCreateModal()"
		(keypress)="openPostopCreateModal()" [disabled]="isDisabled() || isReadonly() || !isPostopCreateEnabled()">
		<i class="material-icons fake-material-icon postoperative-2"></i>
		<div>{{ labels().PLAN_ACTION_COMPONENT_POSTOP_CREATE }}</div>
	</button>
	<button data-testid="SUBSYS2_PLANLIST_ACTION_SEND" class="btn" [title]="labels().PLAN_ACTION_COMPONENT_SEND"
		(click)="openSendModal()" (keypress)="openSendModal()" [disabled]="isDisabled() || !isSendEnabled()">
		<i class="material-icons fake-material-icon send"></i>
		<div>{{ labels().PLAN_ACTION_COMPONENT_SEND }}</div>
	</button>
	<button data-testid="SUBSYS2_PLANLIST_ACTION_DELETE" class="btn" [title]="labels().PLAN_ACTION_COMPONENT_DELETE"
		(click)="openDeleteModal()" (keypress)="openDeleteModal()"
		[disabled]="isDisabled() || isReadonly() || !isDeleteEnabled()">
		<i class="material-icons">delete_outline</i>
		<div>{{ labels().PLAN_ACTION_COMPONENT_DELETE }}</div>
	</button>
	@if (isTlhexUser()) {
	<button data-testid="SUBSYS2_PLANLIST_ACTION_MYHEXPLAN_SETTINGS" class="btn"
		[title]="labels().PLAN_ACTION_COMPONENT_MYHEXPLAN_SETTINGS" (click)="viewPlanSettings()"
		(keypress)="viewPlanSettings()" [disabled]="isDisabled() || isReadonly() || !isMyHexPlanSettingsEnabled()">
		<i class="material-icons">settings_applications</i>
		<div>{{ labels().PLAN_ACTION_COMPONENT_MYHEXPLAN_SETTINGS }}</div>
	</button>
	}
	<button data-testid="SUBSYS2_PLANLIST_ACTION_UPGRADE" class="btn" [title]="labels().PLAN_ACTION_COMPONENT_UPGRADE"
		(click)="openUpgradeModal()" (keypress)="openUpgradeModal()" [disabled]="isDisabled() || !isUpgradeEnabled()">
		<i class="material-icons fake-material-icon upgrade"></i>
		<div>{{ labels().PLAN_ACTION_COMPONENT_UPGRADE }}</div>
	</button>
</div>